module.exports = __webpack_public_path__ + "img/08_L3.5b2a760a.svg";